const SET_IS_MODAL_OPEN = (state, boolean) => { state.isModalOpen = boolean }
const SET_TYPE = (state, value) => { state.type = value }
const SET_SURVEY_ID = (state, value) => { state.surveyId = value }

export default {
  SET_IS_MODAL_OPEN,
  SET_TYPE,
  SET_SURVEY_ID
}
